var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 1C0.447715 1 0 1.44772 0 2L0 36.9809C0 37.8085 0.947793 38.2779 1.60604 37.7763L10.2315 31.2046C10.4057 31.0719 10.6186 31 10.8375 31L39 31C39.5523 31 40 30.5523 40 30V2C40 1.44772 39.5523 1 39 1L1 1ZM9 10C9 9.44772 9.37884 9 9.84615 9L30.1538 9C30.6212 9 31 9.44772 31 10C31 10.5523 30.6212 11 30.1538 11L9.84615 11C9.37884 11 9 10.5523 9 10ZM9 16C9 15.4477 9.37884 15 9.84615 15L30.1538 15C30.6212 15 31 15.4477 31 16C31 16.5523 30.6212 17 30.1538 17H9.84615C9.37884 17 9 16.5523 9 16ZM9.84615 21C9.37884 21 9 21.4477 9 22C9 22.5523 9.37884 23 9.84615 23L30.1538 23C30.6212 23 31 22.5523 31 22C31 21.4477 30.6212 21 30.1538 21L9.84615 21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChat);
export default __webpack_public_path__ + "static/media/icon_Chat.ac86b57fe9e1c868e31d8eb1fdad85da.svg";
export { ForwardRef as ReactComponent };